import * as React from 'react';
import '@atlaskit/css-reset';
import { AtlassianLogo } from '@atlaskit/logo';
import * as searchErrorPath from './SearchError.png';
import { Title, Container, Image, Footer, Content, Subtitle } from '../common/styled';
import { atlassianHomeUrl } from '../../util/atlassian';
import { FormattedMessage } from 'react-intl';
import withLocale from '../common/withLocale';

const DocumentTitle = () => (
  <FormattedMessage id="notFound.pageTitle" defaultMessage="Atlassian | Page Not Found">
    {message => {
      if (typeof message === 'string' && document.title !== message) {
        document.title = message;
      }

      return null;
    }}
  </FormattedMessage>
);

function App() {
  return (
    <Container>
      <DocumentTitle />
      <Content>
        <Image src={searchErrorPath} />
        <Title>Oh no!</Title>
        <Subtitle>
          <FormattedMessage id="notFound.message" defaultMessage="We don't recognize that link." />
        </Subtitle>
      </Content>
      <Footer>
        <a href={atlassianHomeUrl}>
          <AtlassianLogo />
        </a>
      </Footer>
    </Container>
  );
}

export default withLocale(App);
